export default {
  subtitle:
    'Lähetämme valitut tapahtumat POST-pyyntöinä päätepisteisiisi, allekirjoitettuna päätepisteen salaisuudella.',
  regenerate_confirm: 'Luodaanko uusi allekirjoitussalaisuus? Nykyinen salaisuus lakkaa toimimasta heti.',
  delete_confirm: 'Poistetaanko tämä päätepiste? Se lakkaa vastaanottamasta tapahtumia.',
  consecutive_failures: '{{count}} peräkkäistä epäonnistumista',
  columns: {
    url: 'Päätepiste',
    events: 'Tapahtumat',
    status: 'Tila',
    secret: 'Salaisuus',
  },
  statuses: {
    active: 'Aktiivinen',
    disabled: 'Poistettu käytöstä',
    auto_disabled: 'Poistettu käytöstä automaattisesti',
  },
  buttons: {
    create: 'Lisää päätepiste',
    edit: 'Muokkaa',
    regenerate_secret: 'Uusi salaisuus',
    delete: 'Poista',
  },
  toasts: {
    load_error: 'Webhook-päätepisteitä ei voitu ladata.',
    error: 'Jokin meni pieleen. Yritä uudelleen.',
    deleted: 'Päätepiste poistettu.',
  },
};
